export default {
  SET_INSTANCES(state, instances) {
    state.instances = instances;
  },

  SET_INSTANCE(state, updatedInstance) {
    const index = state.instances.collection.findIndex(
      (instance) => instance.id === updatedInstance.id,
    );
    if (index >= 0) {
      state.instances.collection.splice(index, 1, updatedInstance);
    }
  },

  ADD_INSTANCE(state, instance) {
    state.instances.collection.unshift(instance);
  },

  DELETE_INSTANCE(state, id) {
    const index = state.instances.collection.findIndex((instance) => instance.id === id);
    if (index >= 0) {
      state.instances.collection.splice(index, 1);
    }
  },

  SET_EDITING_INSTANCE(state, editingInstance) {
    state.editingInstance = editingInstance;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_PAGE(state, page) {
    state.page = page;
  },

  SET_SORT_BY(state, sortBy) {
    state.sortBy = sortBy;
  },

  SET_ORDER_BY(state, orderBy) {
    state.orderBy = orderBy;
  },

  SET_SEARCH(state, search) {
    state.search = search;
  },
};
